import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select'
import ApiClient from "../../../services/api-client"


const InvoiceTypeEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);
    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    const refSelectInput = useRef(null);


    useEffect(() => {
        focus();
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });

    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };

    const { t } = useTranslation();

    const onSelectChange = val => {
        setSelectedVal(val);
        setTimeout(function () {
            props.api.stopEditing();
            setTimeout(function () {
                props.node.setDataValue("invoiceType", val);
                props.node.setDataValue("selfPricing", false);
            });

            var expenses = props.node.data.selfPricing ? props.node.data.selfPricing : false;
            ApiClient.getClassificationCategoriesOfMyDataInvoice(val.myDataInvoiceType, expenses).then(response => {
                var data = response.data;
                var _optionIncClassCategories = [];
                data.forEach(element => {
                    var _classificationCategoryType;
                    var _classificationValueTypes;
                    _classificationCategoryType = element.classificationCategory;
                    _classificationValueTypes = element.classificationValues;
                    var prefix = _classificationCategoryType.replace("CATEGORY_", "") + ") ";
                    if (props.node.data.selfPricing) {
                        _classificationCategoryType = element.classificationCategory;
                        _classificationValueTypes = element.classificationValues;
                    }


                    _optionIncClassCategories.push({
                        value: _classificationCategoryType,
                        label: prefix + t(_classificationCategoryType),
                        classificationValues: _classificationValueTypes,
                    });
                });
                // console.log( props.node)
                var row_dom = document.querySelector(`.ag-center-cols-container >  div[row-index="${props.node.rowIndex}"][role="row"]`)
                var selfpricing_invoicearr = ["invoice1_1", "invoice1_4", "invoice1_5", "invoice1_6", "invoice2_1", "invoice2_4", "invoice5_1", "invoice5_2"]

                setTimeout(function () {
                    var el = row_dom.querySelector("input[type='checkbox']");
                    props.node.setDataValue("classificationCategoryTypes", _optionIncClassCategories);

                    props.node.setDataValue("classificationCategory", { value: undefined, label: undefined });
                    props.node.setDataValue("classificationValue", { value: undefined, label: undefined });
                    if ((val)) {
                        if (!selfpricing_invoicearr.includes(val.myDataInvoiceType)) {

                            el.disabled = true;
                        }
                        else {
                            el.disabled = false;
                        }
                    }
                    else {
                        el.disabled = false;
                    }


                });
            },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            );
        })

    }
    const onMouseOver = e => {
        refSelectInput.current.setState({ isOpen: true })
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();
        }
    }


    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span onMouseOver={onMouseOver} className="selectCell" ref={refContainer}>
            <Select
                autosize={true}
                menuIsOpen={true}
                defaultValue={selectedVal}
                onChange={onSelectChange}
                onChangeValue={onSelectChange}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                options={props.colDef.cellRendererParams.options} ref={refSelectInput}>
            </Select>
        </span>
    </div>
    );
});

export default InvoiceTypeEditor